import { render } from "./BoolGeneric.vue?vue&type=template&id=0fb9bf86"
import script from "./BoolGeneric.vue?vue&type=script&lang=ts"
export * from "./BoolGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script